module.exports = __webpack_public_path__ + "static/65-29f4c5d3de2b10bfb02385be156f4828.png";